export enum EReactionAwards {
  GoldenJoker = 1,
  Punbelievable,
  MeanieMedal,
  DirtyBirdTrophy,
  Offsensive,
}
